<template>
<div class="loading-box">
  <div class="loading-icon">
    <i class="fa fa-spinner fa-spin fa-5x fa-fw"></i>
    <span class="sr-only">Loading...</span>
  </div>
</div>
</template>

<script>
export default {
};
</script>

<style scoped>
.loading-box {
  width: 100%;
}

.loading-icon {
  width: 100px;
  text-align: center;
  margin: 200px auto;
}
</style>
